import axios from 'axios';
export const deleteMethod = async (url, token) => {
    const response = await axios({
        method:'DELETE',
        url,
        headers: {"Authorization" : `Bearer ${token}`},
      })
   return response;
  }
